import React from 'react';
import {
  Folder as FolderIcon,
  FolderShared as FolderSharedIcon,
  Person as PersonIcon,
  TableChart as DatasetIcon,
  Source as DataSourceIcon,
  AccountTree as PipelineIcon,
} from '@mui/icons-material';
import { Avatar } from '@mui/material';

import type { CategoryName } from '../../theme/tokens';

export type ExplorerItemKind =
  | 'folder'
  | 'personal-root'
  | 'shared-root'
  | 'data-object'
  | 'data-source'
  | 'pipeline';

type KindStyle = {
  label: string;
  icon: React.ReactElement;
  /** The design's category colour for the kind; the icon is drawn in that category's ink. */
  category: CategoryName;
};

const KIND_STYLES: Record<ExplorerItemKind, KindStyle> = {
  folder: { label: 'Folder', icon: <FolderIcon fontSize="small" />, category: 'gold' },
  'personal-root': {
    label: 'Personal workspace',
    icon: <PersonIcon fontSize="small" />,
    category: 'purple',
  },
  'shared-root': {
    label: 'Shared workspace',
    icon: <FolderSharedIcon fontSize="small" />,
    category: 'purple',
  },
  'data-object': { label: 'Dataset', icon: <DatasetIcon fontSize="small" />, category: 'blue' },
  'data-source': {
    label: 'Data source',
    icon: <DataSourceIcon fontSize="small" />,
    category: 'green',
  },
  pipeline: { label: 'Pipeline', icon: <PipelineIcon fontSize="small" />, category: 'pink' },
};

export const kindLabel = (kind: ExplorerItemKind): string => KIND_STYLES[kind].label;

export const KindAvatar: React.FC<{ kind: ExplorerItemKind; size?: number }> = ({
  kind,
  size = 32,
}) => {
  const style = KIND_STYLES[kind];
  return (
    <Avatar
      variant="rounded"
      sx={{ width: size, height: size, bgcolor: `var(--c-${style.category})`, color: `var(--c-${style.category}-on)` }}
      aria-label={style.label}
    >
      {style.icon}
    </Avatar>
  );
};
